import { link } from "@/components/Action.tsx";
import type { FirewallWithType } from "@/modules/network/firewall/firewallApi.ts";
import type { IpAddressWithType } from "@/modules/network/ipAddress/ipAddressApi.ts";
import type { LoadBalancerWithType } from "@/modules/network/loadbalancer/loadBalancerApi.ts";
import type { VpcWithType } from "@/modules/network/vpc/vpcApi.ts";

export function vpcLink({ location, uuid }: VpcWithType) {
    return link({ to: "/network/vpc/$location/$uuid", params: { location, uuid } });
}

export function loadBalancerLink({ location, uuid }: LoadBalancerWithType) {
    return link({ to: "/network/load_balancer/$location/$uuid", params: { location, uuid } });
}

export function ipAddressLink({ location, uuid }: IpAddressWithType) {
    return link({ to: "/network/ip_address/$location/$uuid", params: { location, uuid } });
}

export function firewallLink({ location, uuid }: FirewallWithType) {
    return link({ to: "/network/firewall/$location/$uuid", params: { location, uuid } });
}
